import React, { useContext } from 'react';
import AuthContext from 'providers/Auth/Auth.context';
import { useParams } from 'react-router-dom';
import ShareableLinkUserForm from '../../components/ShareableLinkUserForm';
import ShareableLinkAuthorized from '../../components/ShareableLinkAuthorized';

const ShareableLinkMain: React.FC = () => {
  const { isLoggedIn } = useContext(AuthContext);

  const { shareableLinkId } = useParams<{ shareableLinkId: string }>();

  if (!isLoggedIn)
    return <ShareableLinkUserForm shareableLinkId={shareableLinkId} />;

  return <ShareableLinkAuthorized shareableLinkId={shareableLinkId} />;
};

export default ShareableLinkMain;
